import React, { Component } from "react";
import InputV2 from "../../Components/Inputs/Input/InputV2";
import DropdownV2 from "../../Components/Inputs/Dropdown/DropdownV2";
import CurrencyV2 from "../Inputs/Currency/CurrencyV2";
import DatePickerSingleV2 from "../DatePickers/DatePickerSingle/DatePickerSingleV2";
import ChangeEvents, { VALIDATION_ERROR_MESSAGE } from "./ChangeEvents";
import { fetchParentData } from "../../Flux/Actions/ParentActions";
import BookFiltersStore from "../../Flux/Stores/BookFiltersStore";
import MasterCampaignsStore from "../../Flux/Stores/MasterCampaignsStore";
import PlacementDataStore from "../../Flux/Stores/PlacementDataStore";
import ParentDataStore from "../../Flux/Stores/ParentDataStore";
import RateBuilderV2 from "./RateBuilderV2";
import "../../SASS/layout/errors.scss";
import "./FormBuilderV2.scss";
import TableHelper from "../Table/TableHelper";
import { buildDropdownSearchText, filterDropdownOption } from "../../Components/Inputs/Dropdown/dropdownSearch";
import UpdateStateHelper from "./UpdateStateHelper";

const OSPMDM_4486_ENABLED = true; // enabling always because the API handles whether its enabled or not
// const OSPMDM_4486_ENABLED = process?.env?.REACT_APP_OS_SHARED_SERVICES_API === "https://test-api.publicismedia.com";
const KPI_GOAL_TYPEMAP = {
	Currency: ["385", "382", "381", "386", "380", "389"],
	Percentage: ["391", "387", "383", "388", "392", "384", "390"],
	String: ["379", "393"]
};
const IGNORED_CONFIG_BUCKETS = ["ChildData", "RegEx"];

const MissingData = () => (
	<div>No configuration found. Please visit the Client Configuration to manage this clients data keys. If you have any questions, please reach out to an administrator.</div>
);

class FormBuilderV2 extends Component {
	constructor(props) {
		super(props);
		this.configName = this.props.configName;
		this.state = this.props.state;
		this.updateState = this.props.onUpdate;
		this.autoSelect = this.props.autoSelect;

		this.rateFields = ["PlannedUnits", "Rate", "Cost"];
		this.rateEnabledPlatformIDs = [1, 5, 20, 162];
	}

	componentDidMount = () => {
		this.formulas = BookFiltersStore.getFormulas();
	};

	buildModalInputs = (data, state) => {
		const buildFormData = [];
		const singleOptions = [];
		const rateFieldsInConfig = [];

		const allDataKeys = [];
		let fieldCount = 0;
		Object.keys(data).forEach((bucket) => {
			if (data[bucket].length > 0) {
				data[bucket].forEach((dataNode) => {
					if (this.rateFields.includes(dataNode.Name)) {
						rateFieldsInConfig.push([dataNode, bucket]);
					}
					const dataNodeWithPosition = dataNode;
					if (typeof dataNodeWithPosition === "object") {
						if (dataNode.FieldType !== "Hidden") {
							dataNodeWithPosition.modalPosition = fieldCount;
							fieldCount++;
						}
						allDataKeys.push({ bucket, dataNode: dataNodeWithPosition });
					}
				});
			}
		});
		const allRateFieldsAvailable = rateFieldsInConfig.length === 3 && this.rateEnabledPlatformIDs.includes(this.props.metaData?.PlatformID);
		allDataKeys.forEach((dataKey) => {
			const { dataNode } = dataKey;
			const heading = dataKey.bucket;
			if ((allRateFieldsAvailable && !this.rateFields.includes(dataNode.Name)) || !allRateFieldsAvailable) {
				buildFormData.push(this.returnProperReactComp(dataNode, heading, state));

				if (dataNode.DataType === "Select" && dataNode.Name !== "ParentDescription") {
					if (dataNode.Options.length === 1 && this.props.type && !this.props.type.includes("edit") && dataNode.ParentName === null) {
						singleOptions.push([
							{ value: dataNode.Options[0].OptionID, label: dataNode.Options[0].OptionLabel },
							dataNode.Name,
							heading,
							dataNode.ID,
							dataNode.DataType
						]);
					} else if (
						dataNode.Options.length !== 1 &&
						this.props.type &&
						(!this.props.type.includes("edit") || this.props.type.includes("edit")) &&
						dataNode.ParentName !== null
					) {
						const data = this.returnDataValues(dataNode, state);
						if (data.length === 1) {
							singleOptions.push([{ value: data[0].value, label: data[0].label }, dataNode.Name, heading, dataNode.ID, dataNode.DataType]);
						}
					}
				}
			}
		});
		singleOptions.forEach((dataKey) => {
			if (!state.formData[dataKey[1]] || !state.formData[dataKey[1]]?.value) {
				setTimeout(() => {
					ChangeEvents.handleSelectChange(dataKey[0], dataKey[1], dataKey[2], dataKey[3], dataKey[4], this.updateState);
				}, 0);
			}
		});
		if (Object.keys(state.formData).length === 0 && this.props.configName === "NewPlacement") {
			this.autoSelect();
		}
		if (buildFormData.length <= 1 && !["create mastercampaign", "edit mastercampaign"].includes(this.props.type)) {
			return <MissingData />;
		}
		return (
			<>
				{buildFormData}
				{allRateFieldsAvailable && (
					<RateBuilderV2
						rateFieldsInConfig={rateFieldsInConfig}
						data={data}
						state={state}
						updateState={this.updateState}
						updateCalculatedField={this.props.updateCalculatedField}
						type={this.props.type}
						parentRef={this.props.parentRef}
						formEl={this.props.formEl}
					/>
				)}
			</>
		);
	};

	returnProperReactComp = (dataNode, heading, state) => {
		const el = dataNode;
		if (el.Name === "CreativeAgencyOwner") {
			return;
		}
		if (el.FieldType !== "Hidden") {
			// add special logic for KPIGoalDetails to map types based on the KPIGoals selection.
			if (OSPMDM_4486_ENABLED && el.Name == "KPIGoalDetails" && this.props.configName !== "NewPlacement") {
				el.DataType = "String";
				if (state?.formData?.KPIGoal?.value) {
					const KPIGoalValue = state?.formData?.KPIGoal?.value?.value;
					for (let i = 0; i < Object.entries(KPI_GOAL_TYPEMAP).length; i++) {
						const [dataType, goalCodes] = Object.entries(KPI_GOAL_TYPEMAP)[i];
						if (goalCodes.indexOf(KPIGoalValue) != -1) {
							el.DataType = dataType;
							break;
						}
					}
				}
			}

			if (el.DataType === "String" || el.DataType === "Integer" || el.DataType === "Percentage") {
				let type = "text";

				if (el.DataType === "Integer" || el.DataType === "Percentage") {
					type = "number";
				}

				let value = state.formData[el.Name] ? state.formData[el.Name].value : "";
				let label = el.Label;

				if (OSPMDM_4486_ENABLED && el.Name === "KPIGoalDetails" && this.props.configName !== "NewPlacement") {
					if (el.DataType === "Percentage") {
						value = value.replace(/[^0-9]/g, "") || "0.00";
						value = `${value.slice(0, value.length - 2)}.${value.slice(-2)}`;
						value = parseFloat(value).toFixed(2);
						value = `%${value}`;
						label = `KPI Goal (Percentage)`;
					} else if (el.DataType === "String") {
						label = `KPI Goal (Text)`;
					}
				}

				return (
					<div className="form__group width--pct--50" key={el.Name}>
						<InputV2
							readOnly={
								this.props.fieldsDisabled
									? this.props.fieldsDisabled
									: el.Name === "PlannedUnits" && this.props.isDraft === true
										? true
										: state.formData[el.Name]
											? state.formData[el.Name].disabled
											: false
							}
							type={"text"}
							name={el.Name}
							className="like--input"
							id={el.ID}
							dataConfig={heading}
							labelText={label}
							required={true}
							value={value}
							fieldDescription={el.FieldDescription}
							pattern={el.ValidationString || undefined}
							error={el.ValidationString ? VALIDATION_ERROR_MESSAGE : undefined}
							handleInputChange={(event) => {
								if (type === "text") {
									let validation = this.props.data.RegEx;
									if (el.IsSubTaxonomyKey === true) {
										if (this.props.data.SubTaxonomyRegEx && this.props.data.SubTaxonomyRegEx.length === 2) {
											validation = this.props.data.SubTaxonomyRegEx;
										}
									}
									if (heading === "TaxonomyData" || heading === "MetaData") {
										ChangeEvents.handleInputChange(event, this.updateState, "TaxOrMeta", validation, undefined, el.ValidationString);
									} else if (OSPMDM_4486_ENABLED && el.Name === "KPIGoalDetails" && this.props.configName !== "NewPlacement") {
										ChangeEvents.handleInputChange(event, this.updateState, label === "KPI Goal (Text)" ? "text" : undefined, validation);
									} else if (this.props.type === "create mastercampaign" || this.props.type === "edit mastercampaign") {
										ChangeEvents.handleInputChange(event, this.updateState, type, validation, 50);
									} else {
										ChangeEvents.handleInputChange(event, this.updateState, type, validation);
									}
								} else if (type === "number") {
									if (OSPMDM_4486_ENABLED && el.Name === "KPIGoalDetails" && this.props.configName !== "NewPlacement" && el.DataType == "Percentage") {
										ChangeEvents.handleInputChange(event, this.updateState);
									} else {
										ChangeEvents.handleInputChange(event, this.updateState, type);
									}
								} else {
									ChangeEvents.handleInputChange(event, this.updateState);
								}
							}}
						/>
						<div className={`errors__${el.Name}`} />
					</div>
				);
			}

			if (el.DataType === "Currency") {
				if (el.FieldType !== "Calculated") {
					if (el.Name !== "Rate") {
						let label = el.Label;
						// KPI Goal Amount/Percentage/String
						if (OSPMDM_4486_ENABLED && el.Name === "KPIGoalDetails" && state?.formData?.KPIGoal?.value && this.props.configName !== "NewPlacement") {
							label = `KPI Goal (Currency/Amount)`;
						}

						return (
							<div className="form__group width--pct--50" key={el.Name}>
								<CurrencyV2
									readOnly={this.props.fieldsDisabled ? this.props.fieldsDisabled : state.formData[el.Name] ? state.formData[el.Name].disabled : false}
									name={el.Name}
									id={el.ID}
									label={el.Label}
									className="like--input"
									required={true}
									dataConfig={heading}
									value={state.formData[el.Name] ? state.formData[el.Name].value : 0}
									fieldDescription={el.FieldDescription}
									onCurrencyChange={(value, name, dataConfig, id, dataType) => {
										ChangeEvents.handleCurrencyChange(value, name, dataConfig, id, dataType, this.updateState);
									}}
									precision={el.Name !== "Budget" && el.Name !== "Cost" && el.Name !== "KPIGoalDetails" ? 5 : 2}
									{...(el.Name == "Budget" && el.IsReadOnly ? { readOnly: true } : {})}
								/>
								<div className={`errors__${el.Name}`} />
							</div>
						);
					}
					const currencySymbol = BookFiltersStore.getCurrencySymbol();
					let stringRate = state.formData[el.Name] ? state.formData[el.Name].value.toString() : "";
					if (stringRate && el.Name == "Rate") {
						if (stringRate.indexOf(".") !== -1) {
							if (stringRate.slice(stringRate.indexOf(".") + 1).length > 5) {
								stringRate = stringRate.slice(0, stringRate.indexOf(".") + 1) + stringRate.slice(stringRate.indexOf(".") + 1, stringRate.indexOf(".") + 6);
								stringRate = parseFloat(stringRate);
							}
						}
					}
					return (
						<div className="form__group width--pct--50" key={el.Name}>
							<InputV2
								readOnly={this.props.fieldsDisabled ? this.props.fieldsDisabled : state.formData[el.Name] ? state.formData[el.Name].disabled : false}
								type={"text"}
								name={el.Name}
								className="like--input"
								id={el.ID}
								dataConfig={heading}
								labelText={el.Label}
								required={true}
								value={state.formData[el.Name] ? (currencySymbol !== null ? currencySymbol : "") + stringRate : (currencySymbol !== null ? currencySymbol : "") + 0}
								fieldDescription={el.FieldDescription}
								handleInputChange={(event) => {
									ChangeEvents.handleRateChange(event, this.updateState, this.props.state);
								}}
							/>
							<div className={`errors__${el.Name}`} />
						</div>
					);
				}
				return (
					<div className="form__group width--pct--100 flex__container flex--ai--l flex--jc--l flex--dir--col" key={el.Name}>
						<div className="flex__container flex--ai--c">
							<CurrencyV2
								readOnly={true}
								name={el.Name}
								id={el.ID}
								className="mediaMath--total like--heading"
								dataConfig={heading}
								label={el.Label}
								required={true}
								fieldDescription={el.FieldDescription}
								value={state.formData[el.Name] ? state.formData[el.Name].value : 0}
							/>
						</div>
						<div className={`errors__${el.Name}`} />
					</div>
				);
			}

			if (el.DataType === "Date") {
				if (this.props.rerenderDP) {
					return (
						<div className="form__group width--pct--50" key={el.Name}>
							{!state.loading && (
								<DatePickerSingleV2
									minDate={state.metaData ? state.metaData.StartDate : null}
									maxDate={state.metaData ? state.metaData.EndDate : null}
									dateFormat="Y/m/d"
									name={el.Name}
									id={el.ID}
									label={el.Label}
									required={true}
									readOnly={this.props.fieldsDisabled ? this.props.fieldsDisabled : state.formData[el.Name] ? state.formData[el.Name].disabled : false}
									value={state.formData[el.Name] ? state.formData[el.Name].value : ""}
									// minDate={this.state.dateSettings.minDate}
									dataConfig={heading}
									fieldDescription={el.FieldDescription}
									onDateChange={(name, date, dataConfig, id, dataType) => {
										ChangeEvents.handleDateChange(name, date, dataConfig, id, dataType, this.updateState);
									}}
									position={el.modalPosition}
									configName={this.configName}
								/>
							)}

							<span className={`errors__${el.Name}`} />
						</div>
					);
				}
				return (
					<div className="form__group width--pct--50" key={el.Name}>
						<DatePickerSingleV2
							minDate={state.metaData ? state.metaData.StartDate : null}
							maxDate={state.metaData ? state.metaData.EndDate : null}
							dateFormat="Y/m/d"
							name={el.Name}
							required={true}
							id={el.ID}
							label={el.Label}
							readOnly={this.props.fieldsDisabled ? this.props.fieldsDisabled : state.formData[el.Name] ? state.formData[el.Name].disabled : false}
							value={state.formData[el.Name] ? state.formData[el.Name].value : ""}
							dataConfig={heading}
							fieldDescription={el.FieldDescription}
							onDateChange={(name, date, dataConfig, id, dataType) => {
								ChangeEvents.handleDateChange(name, date, dataConfig, id, dataType, this.updateState);
							}}
							position={el.modalPosition}
							configName={this.configName}
						/>

						<span className={`errors__${el.Name}`} />
					</div>
				);
			}

			if (el.DataType === "Select") {
				let width = "50";
				let line = "";
				if (heading === "ParentData") {
					width = "100";
					line = <hr />;
				}
				let data = this.returnDataValues(el, state);

				if (heading === "ParentData" && this.props.type === "newPlacement" && this.props.metaData?.PlatformID == 5) {
					data.push({ label: "Search Order", value: "Search Order" });
				}
				if (state.formData[el.Name]) {
					if (state.formData[el.Name].value !== null) {
						data = data.filter((option) => {
							return option.value !== state.formData[el.Name].value.value;
						});
					}
				}

				// Removing duplicates from ParentData in Placement modal
				if (heading === "ParentData") {
					const removedDuplicates = [];
					const lookupObject = {};
					for (const i in data) {
						lookupObject[data[i].value] = data[i];
					}
					for (const i in lookupObject) {
						removedDuplicates.push(lookupObject[i]);
					}
					data = removedDuplicates;
				}

				let isDisabled = false;
				// let parentName = null;
				if (el.ParentName && el.ParentName !== null) {
					let parentInConfig = false;
					const keys = Object.keys(this.props.data);
					keys.forEach((key) => {
						if (!IGNORED_CONFIG_BUCKETS.includes(key)) {
							this.props.data[key].forEach((field) => {
								if (field.Name === el.ParentName) {
									parentInConfig = true;
								}
							});
						}
					});
					if (parentInConfig === true) {
						if (!state.formData[el.ParentName] || state.formData[el.ParentName].value === null || state.formData[el.ParentName].value === "") {
							isDisabled = true;
						}
					}
					// parentName = `(Parent: ${el.ParentName})`
				} else if (el.ParentName === null) {
					if (state.formData[el.Name]) {
						isDisabled = state.formData[el.Name].disabled;
					} else {
						isDisabled = false;
					}
				}

				if (this.props.fieldsDisabled && this.props.fieldsDisabled === true && heading !== "ParentData") {
					isDisabled = true;
				}

				if (heading === "ParentData" && this.props.type === "edit lineitem") {
					isDisabled = true;
				}

				if (
					this.props.formEl == "edit_package" &&
					el.Name == "RateType" &&
					PlacementDataStore?.getData?.()?.some((datum) => datum?.IsPrismaBudgetLocked == "True") &&
					(this.props?.parentRef?.props?.packageData?.ExternalSystemStatusID == "3" ||
						this.props?.parentRef?.props?.packageData?.ExternalSystemStatusID == "6" ||
						this.props?.parentRef?.props?.packageData?.ExternalSystemStatusID == "2")
				) {
					isDisabled = true;
				}

				// disable gcm fields
				if (
					this.props.metaData?.PlatformID === 1 &&
					BookFiltersStore?.getSyncStatuses()?.find(({ MasterPlatformID }) => MasterPlatformID == 1)?.SyncStatus &&
					this.props.metaData?.ExternalSystemStatusID === 3 &&
					this.props.syncStatus == 3
				) {
					if (this.props.formEl == "edit_package" && TableHelper.GCM_PACKAGE_DISABLED_CELLS?.includes(el.Name)) {
						isDisabled = true;
					}

					if (this.props.formEl == "edit_placement" && TableHelper.GCM_PLACEMENT_DISABLED_CELLS?.includes(el.Name)) {
						isDisabled = true;
					}
				}

				// let header = el.Label;
				// if (parentName !== null) {
				// 	header = `${el.Label} ${parentName}`
				// }

				return (
					<div className={`form__group width--pct--${width} dropdown__wrapper`} key={el.Name}>
						<DropdownV2
							className=""
							placeholder={`Select ${el.Label}`}
							name={el.Name}
							label={el.Label}
							data={data}
							required={!(this.props?.configName === "lineItemConfig" && el?.Name === "ParentDescription")}
							dataConfig={heading}
							dataType={el.DataType}
							ref={el.Name}
							value={state.formData[el.Name] ? state.formData[el.Name].value : null}
							isClearable
							isDisabled={isDisabled}
							id={el.ID}
							fieldDescription={el.FieldDescription}
							filterOption={el.Name === "RateType" ? filterDropdownOption : undefined}
							handleChange={(selectedOption, selectName, dataConfig, id, dataType) => {
								if (OSPMDM_4486_ENABLED && selectName == "KPIGoal" && this.props.configName !== "NewPlacement") {
									if (state?.formData?.KPIGoalDetails?.value) {
										state.formData.KPIGoalDetails.value = "";
									}

									if (selectedOption == null) {
										state.formData.KPIGoalDetails.disabled = true;
									} else {
										state.formData.KPIGoalDetails.disabled = false;
									}
								}

								ChangeEvents.handleSelectChange(selectedOption, selectName, dataConfig, id, dataType, this.updateState);

								if (heading === "ParentData" && this.props.configName !== "lineItemConfig") {
									if (selectedOption) {
										if (selectedOption.value === "STANDALONE") {
											this.props.handleStandalone();
										} else if (selectedOption.value === "Search Order") {
											this.props.handleSearchOrder();
										} else {
											this.props.setLoading(() => {
												const filters = BookFiltersStore.getChoicesState();
												const campaignUniqueIdCode = MasterCampaignsStore.getParentCampaignUniqueID();
												fetchParentData(filters, campaignUniqueIdCode, selectedOption.value, this.props.auditLevelID);
											});
										}
									} else {
										ParentDataStore.resetParentData();
									}
								}
							}}
							// isMulti={true}
						/>
						{/* {line} */}
						<div className={`errors__${el.Name}`} />
					</div>
				);
			}
		}
	};

	/* BUILD DROPDOWN OPTIONS */
	returnDataValues = (dataValueObject, state) => {
		const mapDropdownOption = (option, parentName = null) => {
			return {
				...option,
				searchText: buildDropdownSearchText(option),
				value: option.OptionID,
				label: option.OptionLabel,
				...(parentName ? { parentName } : {})
			};
		};

		if (dataValueObject.ParentName === null) {
			// add special logic for KPIGoals to filter based on the CampaignGoal selection.
			if (OSPMDM_4486_ENABLED && this.props.configName !== "NewPlacement") {
				if (state?.formData?.CampaignGoal?.value) {
					if (dataValueObject.Name === "KPIGoal") {
						const selectedCampaignGoalValue = state.formData.CampaignGoal.value.value;
						dataValueObject.Options = dataValueObject.Options.filter(({ ParentOptionID }) => {
							if (ParentOptionID != undefined && typeof ParentOptionID === "string") {
								const enabledCampaignCodes = ParentOptionID?.split(",");
								return enabledCampaignCodes?.includes(selectedCampaignGoalValue);
							}
						});
						if (state?.formData?.KPIGoal?.disabled && state?.formData?.KPIGoalDetails?.disabled) {
							state.formData.KPIGoal.disabled = false;
							state.formData.KPIGoalDetails.disabled = true;
						}
					}
				} else {
					state.formData = {
						...state.formData,
						KPIGoal: { value: "", disabled: true, parentName: null },
						KPIGoalDetails: { value: "", disabled: true, parentName: null }
					};
				}
			}

			this.dataValues = dataValueObject.Options.map((el) => {
				return mapDropdownOption(el);
			});

			if (["packagesConfig", "NewPlacement"].includes(this.props.configName) && dataValueObject?.Name === "BuyType") {
				if (
					(this.props.configName === "NewPlacement" && state?.formData?.ParentDescription?.value?.value !== "Search Order") ||
					this.props.configName === "packagesConfig"
				) {
					this.dataValues = this.dataValues.filter((value) => {
						return value.label !== "Search";
					});
				}
			}

			return this.dataValues;
		}
		let parentInConfig = false;
		const keys = Object.keys(this.props.data);
		keys.forEach((key) => {
			if (!IGNORED_CONFIG_BUCKETS.includes(key)) {
				this.props.data[key].forEach((field) => {
					if (field.Name === dataValueObject.ParentName) {
						parentInConfig = true;
					}
				});
			}
		});
		if (parentInConfig === true || this.props.configName === "ActivationPlatform") {
			if (state.formData[dataValueObject.ParentName] && state.formData[dataValueObject.ParentName].value !== null) {
				// This check is specifically for Prisma Packages and Placements that have "Search" or "Social" selected as the Buy Type. In that scenario, we don't want orphaned values to be in the BuyCategory dropdown
				const searchOrSocialSelected =
					["packagesConfig", "NewPlacement"].includes(this.props.configName) &&
					["Search", "Social"].includes(state?.formData?.BuyType?.value?.label) &&
					dataValueObject?.Name === "BuyCategory";

				const filteredOptions = dataValueObject.Options.filter((option) => {
					const parsedOptions = option?.ParentOptionID?.split?.(",");
					const testOption = state?.formData?.[dataValueObject.ParentName]?.value?.value?.toString?.();
					return parsedOptions?.includes?.(testOption);
				});
				if (filteredOptions.length !== 0 && !searchOrSocialSelected) {
					filteredOptions.push(
						...dataValueObject.Options.filter((option) => {
							return !option.ParentOptionID;
						})
					);
				}
				if (filteredOptions.length > 0) {
					this.dataValues = filteredOptions.map((el) => {
						return mapDropdownOption(el, dataValueObject.ParentName);
					});
					return this.dataValues;
				}
				this.dataValues = dataValueObject.Options.map((el) => {
					return mapDropdownOption(el, dataValueObject.ParentName);
				});
				return this.dataValues;
			}
			this.dataValues = dataValueObject.Options.map((el) => {
				return mapDropdownOption(el);
			});
			return this.dataValues;
		}
		if (parentInConfig === false && this.props.configName !== "ActivationPlatform") {
			const config = MasterCampaignsStore.getActivationConfig();
			const selectedCampaign = UpdateStateHelper.matchParentCampaign();
			if (selectedCampaign !== null && selectedCampaign !== undefined) {
				const campaignKeys = Object.keys(selectedCampaign);
				let parentValue = null;
				let selectedOptionID;
				campaignKeys.forEach((key) => {
					if (key === dataValueObject.ParentName) {
						parentValue = selectedCampaign[key];
					}
				});
				const configKeys = Object.keys(config);
				configKeys.forEach((key) => {
					if (!IGNORED_CONFIG_BUCKETS.includes(key)) {
						config[key].forEach((field) => {
							if (field?.Name === dataValueObject.ParentName) {
								field?.Options.forEach((option) => {
									if (option.OptionLabel === parentValue) {
										selectedOptionID = option.OptionID;
									}
								});
							}
						});
					}
				});
				const filteredOptions = dataValueObject.Options.filter((option) => {
					const parentOptions = option.ParentOptionID?.split(",");
					return parentOptions.includes(selectedOptionID);
				});
				if (filteredOptions.length !== 0) {
					filteredOptions.push(
						...dataValueObject.Options.filter((option) => {
							return !option.ParentOptionID;
						})
					);
				}
				if (filteredOptions.length > 0 && parentValue !== null) {
					this.dataValues = filteredOptions.map((el) => {
						return mapDropdownOption(el, dataValueObject.ParentName);
					});
					return this.dataValues;
				}
				this.dataValues = dataValueObject.Options.map((el) => {
					return mapDropdownOption(el, dataValueObject.ParentName);
				});
				return this.dataValues;
			}
			this.dataValues = dataValueObject.Options.map((el) => {
				return mapDropdownOption(el, dataValueObject.ParentName);
			});
			return this.dataValues;
		}
	};
	/* ====================== */

	render() {
		if (this.props.data && this.props.state && this.props.state.open === true) {
			return this.buildModalInputs(this.props.data, this.props.state);
		}
		return null;
	}
}

export default FormBuilderV2;
